/**
 * Skip link component for keyboard navigation accessibility
 * Allows users to bypass repetitive navigation and jump to main content
 * Follows WCAG 2.1 AA guideline 2.4.1 (Bypass Blocks)
 */
const SkipLink = ({ targetId = 'main-content', label = 'Skip to main content' }) => {
  return (
    <a 
      href={`#${targetId}`}
      className="sr-only"
      onClick={(e) => {
        // Ensure focus moves to target after navigation
        const target = document.getElementById(targetId);
        if (target) {
          e.preventDefault();
          target.focus();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }}
    >
      {label}
    </a>
  );
};

export default SkipLink;
